module.exports = __webpack_public_path__ + "static/serenity_lake-0d7bfb6874c0393cafe20a4f09e27d1f.jpg";